import axios from 'axios';
import { config } from "./../../constants";
import { popupError, allStorage } from "../../components/helpers/Helpers";
import moment from "moment";
const vm = this;
const header = {
  headers: {
    Accept: "application/json",
  },
};
export default () => {
  var headers = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
      // "Access-Control-Allow-Origin": "*"
    },
  };

  var api = axios.create({
    baseURL: process.env.REACT_APP_API_URL_03,
    withCredentials: false,
    ...headers(),
  });

  api.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      console.log(error);
      return Promise.reject(error);
    }
  );

  return api;
};
export async function checkDipChipStatus(head_token, data) {
  try {
 
    const saveData = [
      {
        name: "dipchip_status",
        url: `${config.baseAPIURL03}/form/dipchip_status/selbyhead`,
        postData: {
          head_token: head_token,
          id_card: data?.cardId,
          ae_code: data?.aeCode
        },
      },
    ];
    const res = await axios.post(saveData[0].url, saveData[0].postData, header);
    // Check if the response is valid and successful
    if (res?.data?.Data?.[0]?.IsSuccess === 1) {
      const dipchipData = res?.data?.Data?.[0].Data?.[0]

      await saveDipchip(dipchipData, head_token, data)
      return true; // Success, move to the next step
    } else {
      return  false; // Failure, fallback step
    }
  } catch (error) {
    throw error;
  }
}
export async function saveDipchip(dipchipData, head_token, data) {
  try {
    console.log(data);
    
    const complete_date = moment(dipchipData.SAfdp_CompleteDate?.date, 'YYYY-MM-DD HH:mm:ss.SSSSSS');
    const saveData = [
      {
        name: "dipchip_status",
        url: `${config.baseAPIURL03}/form/dipchip/manp`,
        postData: {
          head_token: head_token,
          id_card: data?.cardId,
          ae_code: data?.aeCode,
          firstname: dipchipData.SAfdp_FirstName,
          lastname: dipchipData.SAfdp_LastName,
          middlename: dipchipData.SAfdp_MiddleName,
          birthday: dipchipData.SAfdp_Birthday,
          respose_code: dipchipData.SAfdp_ResposeCode,
          respose_desc: dipchipData.SAfdp_ResposeDesc,
          is_error: dipchipData.SAfdp_IsError,
          complete_date: complete_date.format('YYYY-MM-DD HH:mm:ss.SSS'),
          channel: "OA",
          mkt_remark: dipchipData.SAfdp_MKTRemark,
          doc_ref1: dipchipData.SAfdp_Doc_ref1,
          doc_ref2: dipchipData.SAfdp_Doc_ref2,
        },
      },
    ];
    await axios.post(
      saveData[0].url,
      saveData[0].postData,
      header
    )
      .then(async (res) => {
        let currentStep = "";
        if (res?.data?.Data?.[0]?.IsSuccess === 1) {
          localStorage.setItem("pass_dipchip", true);
          currentStep = "idc_address_choose"
        }
        return currentStep
      }).catch((err) => {
        throw err;
      })
  } catch (error) {
    throw error;
  }

};
export async function saveComeback(type, head_token) {
  var last_stamp = JSON.stringify(allStorage());
  var title_mss = "";
  var mss = "";
  const ops = {
    method: "POST",
    headers: header,
    data: {
      last_stamp: last_stamp,
      head_token: head_token,
      stamp_page: type,
    },
    url: config.baseAPIURL03 + "/form/comeback/manp",
  };

  await axios(ops)
    .then(async (res) => {
      let keys = Object.keys(localStorage),
        i = keys.length;
      while (i--) {
      }
      if (type === "NDID") {
        localStorage.setItem("currentStep", "ndid_info");
      } else if (type === "EKYC") {
        localStorage.setItem("currentStep", "ekyc_list");
      }
    })
    .catch((error) => {
      console.log(error);

      if (!!error.isAxiosError && !error.response) {
        title_mss = "เกิดข้อผิดพลาด";
        mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
      } else {
        title_mss = "เกิดข้อผิดพลาด";
        mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
      }
      popupError(mss, title_mss);
      return;
    });
};